export * from './ActorQuerySourceIdentifyHypermediaSparql';
export * from './QuerySourceSparql';
